import { render, staticRenderFns } from "./NotFound.htm?vue&type=template&id=5288a97a&scoped=true&"
import script from "./NotFound.ts?vue&type=script&lang=js&"
export * from "./NotFound.ts?vue&type=script&lang=js&"
import style0 from "./NotFound.scss?vue&type=style&index=0&id=5288a97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288a97a",
  null
  
)

export default component.exports